import React from "react";
import "../KVKK/KVKK.css";

const AydinlatmaMetni = () => {
  return (
    <div className="kvkk-page">
      <section className="kvkk-hero">
        <h1>Kişisel Verilerin İşlenmesine Yönelik <span>Lingify Aydınlatma Metni</span></h1>
      </section>

      <div className="kvkk-content">
        <div className="kvkk-container">

          <table className="kvkk-info-table">
            <tbody>
              <tr><td><strong>Veri Sorumlusu</strong></td><td></td></tr>
              <tr><td>Unvanı</td><td>LİNGİFY SAĞLIK TEKNOLOJİLERİ ANONİM ŞİRKETİ ("Satıcı")</td></tr>
              <tr><td>Adresi</td><td>REŞİTPAŞA MAH. KATAR CAD. İTÜ ARI TEKNOKENT 3 BİNASI NO: 4 İÇ KAPI NO: B204 SARIYER / İSTANBUL</td></tr>
              <tr><td>MERSİS</td><td>0608171176500001</td></tr>
              <tr><td>E-posta</td><td>info@lingify.co</td></tr>
            </tbody>
          </table>

          <p>LİNGİFY SAĞLIK TEKNOLOJİLERİ ANONİM ŞİRKETİ ("LİNGİFY") olarak kişisel verilerinizin korunmasına değer veriyor, dolayısıyla sizin de aynı hassasiyeti göstermenizi bekliyoruz. Bu sebeple hangi kişisel verilerinizi ne amaçla kullandığımızı detaylarıyla anlatan bu metni okumanız, bunların idari ve teknik güvenliğinden "Veri Sorumlusu" sıfatıyla sorumlu olan LİNGİFY'ın yükümlülüklerini net bir şekilde anladığınızı göstermeniz bizim için çok önemlidir.</p>

          <h2>Neden Bu Metni Okuyorum?</h2>
          <p>7 Nisan 2016 tarihinde yürürlüğe giren 6698 sayılı Kişisel Verilerin Korunması Kanununun ("KVKK") 10. maddesi, kişisel verileri işlenen (kullanılan) kişilerin (KVKK'da ilgili kişi olarak ifade edilmektedir) bu verileri kullanan "Veri Sorumlusu" tarafından bilgilendirilmesini zorunlu kılmaktadır. Bizler de Veri Sorumlusu olarak sizlere hakkında işleyeceğimiz kişisel verilerle ilgili bilgilendirildiğinizi ispat etmek durumundayız.</p>
          <p>Bu aydınlatma metni, başvuru formu kapsamında Google Forms (Google Workspace) üzerinden elde edilen kişisel verilerinizin, 6698 sayılı KVKK uyarınca işlenmesine ilişkin olarak sizleri bilgilendirmek amacıyla hazırlanmıştır (KVKK m.10).</p>

          <h2>İşlenen Kişisel Veriler ve Kategorileri</h2>
          <ul>
            <li><strong>Kimlik ve İletişim:</strong> ad-soyad, e-posta, telefon</li>
            <li><strong>Profesyonel Bilgi:</strong> tecrübe alanı, sunum yapma tercihi</li>
            <li><strong>Dijital Kimlik/Link:</strong> profil/portföy bağlantıları</li>
            <li><strong>Etkileşim Tercihleri:</strong> etkinlikten beklenti, ilgi alanları</li>
            <li><strong>Hukuki İşlem:</strong> aydınlatma/izin/onay kayıtları (checkbox, zaman damgası)</li>
            <li><strong>İşlem Güvenliği:</strong> IP, cihaz/uygulama bilgisi, teknik log (hizmet sağlayıcı nezdinde)</li>
          </ul>
          <p className="kvkk-note"><strong>Not:</strong> Bu form özel nitelikli kişisel veri talep etmez. Lütfen sağlığınıza, cezai hükmünüze vb. özel nitelikli verileri formda paylaşmayınız.</p>

          <h2>Toplama Yöntemi ve Hukuki Sebepler</h2>
          <p>Verileriniz elektronik ortamda Google Forms aracılığıyla toplanır. Aşağıdaki hukuki sebeplere dayanır:</p>
          <ul>
            <li><strong>Sözleşmenin kurulması/ifası</strong> (KVKK m.5/2-c): etkinlik başvurunuzun alınması, katılımın ve program akışının yönetimi, sunucu seçimi.</li>
            <li><strong>Meşru menfaat</strong> (m.5/2-f): katılımcı eşleştirme (co-founder matching), etkinlik güvenliği ve raporlama (temel haklarınıza zarar vermemek kaydıyla).</li>
            <li><strong>Açık rıza</strong> (m.5/1):
              <ul>
                <li>etkinlik sonrası bülten/duyuru/pazarlama iletileri,</li>
                <li>iletişim bilgilerinizin diğer katılımcılarla paylaşılması (eşleştirme/iletişim),</li>
                <li>etkinlikte çekilecek fotoğraf-video kullanım ve paylaşımı.</li>
              </ul>
            </li>
          </ul>

          <h2>İşleme Amaçları</h2>
          <ul>
            <li>Başvuruların alınması, katılımcı iletişimi, program/lojistik planlama</li>
            <li>Eşleştirme (co-founder matching) süreçlerinin yürütülmesi</li>
            <li>(Varsa) sunum başvurularının değerlendirilmesi</li>
            <li>Etkinliğe ilişkin bilgilendirme (güncel tarih/saat/yer, kurallar)</li>
            <li>E-posta/SMS ile topluluk ve etkinlik duyuruları, bülten</li>
          </ul>

          <h2>Aktarımlar</h2>
          <p>Kişisel verileriniz, amaçla bağlantılı ve sınırlı olmak üzere:</p>
          <ul>
            <li><strong>Hizmet sağlayıcılarımıza</strong> (Google Workspace/Formlar, e-posta/CRM, BT/altyapı, etkinlik mekanı ve organizasyon partnerleri),</li>
            <li><strong>Yetkili kurum ve kuruluşlara</strong> (mevzuattan doğan yükümlülükler kapsamında),</li>
            <li><strong>Diğer katılımcılara</strong> (ad-soyad, e-posta/telefon, profil linki; eşleştirme/iletişim amacıyla) aktarılabilir.</li>
          </ul>

          <h2>Yurt Dışına Aktarım</h2>
          <p>Google Forms/Workspace kullanımına bağlı olarak verileriniz <strong>yurt dışında bulunan sunuculara</strong> aktarılabilir veya orada saklanabilir. Bu aktarım <strong>KVKK m.9</strong> kapsamındaki uygun aktarım mekanizmaları (ör. yeterlilik kararı, taahhütname/standart sözleşme, <strong>açık rıza</strong>) ve gerekli idari-teknik tedbirlerle gerçekleştirilir. Pazarlama amaçlı e-posta/CRM hizmetleri yurtdışı altyapılardan yürütülecekse aynı mekanizmalar uygulanır.</p>

          <h2>Saklama Süreleri</h2>
          <ul>
            <li>Etkinlik yönetimi ve başvuru kayıtları: etkinlik bitişinden itibaren 2 yıl</li>
            <li>Sunum başvuru/değerlendirme kayıtları: 2 yıl</li>
            <li>Pazarlama/duyuru izni: geri çekilene kadar (çekilmesi halinde ilgili kayıtlar güncellenir/silinir)</li>
            <li>Süresi dolan veriler, mevzuata ve iç politika-prosedürlerimize uygun olarak silinir, yok edilir veya anonimleştirilir.</li>
          </ul>

          <h2>İlgili Kişi Haklarınız (KVKK m.11)</h2>
          <p>Lingify'a başvurarak;</p>
          <ul>
            <li>verilerinizin işlenip işlenmediğini öğrenme, bilgi talep etme,</li>
            <li>işleme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>yurt içi/yurt dışı aktarılan üçüncü kişileri bilme,</li>
            <li>eksik/yanlış işlenen verilerin düzeltilmesini isteme,</li>
            <li>işlenmesini gerektiren sebeplerin ortadan kalkması halinde silme/yok edilmesini isteme,</li>
            <li>işleme faaliyetlerine itiraz etme,</li>
            <li>zarara uğramanız halinde tazminat talep etme haklarınıza sahipsiniz.</li>
          </ul>

          <h2>8) Başvuru Usulü</h2>
          <p>Taleplerinizi KVKK Veri Sorumlusuna Başvuru Usul ve Esasları'na uygun olarak;</p>
          <ul>
            <li>e-posta: <strong>info@lingify.co</strong> (sistemimizde kayıtlı adresinizi kullanarak) bize iletebilirsiniz.</li>
          </ul>
          <p>Başvurularınız <strong>en geç 30 gün içinde</strong> sonuçlandırılır.</p>

          <hr className="kvkk-divider" />

          <table className="kvkk-info-table">
            <tbody>
              <tr><td>Unvanı</td><td>LİNGİFY SAĞLIK TEKNOLOJİLERİ ANONİM ŞİRKETİ ("Satıcı")</td></tr>
              <tr><td>Adresi</td><td>REŞİTPAŞA MAH. KATAR CAD. İTÜ ARI TEKNOKENT 3 BİNASI NO: 4 İÇ KAPI NO: B204 SARIYER / İSTANBUL</td></tr>
              <tr><td>MERSİS</td><td>0608171176500001</td></tr>
              <tr><td>E-posta</td><td>info@lingify.co</td></tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  );
};

export default AydinlatmaMetni;
